import { redirect } from '@tanstack/react-router';

import { isAuthenticated, isExpired, clearTokens } from './auth';

/**
 * Auth guard for protected routes.
 * Clears expired tokens and redirects to /$slug/auth if not authenticated.
 */
export function requireAuth(slug: string) {
  if (isExpired()) {
    clearTokens();
  }

  if (!isAuthenticated()) {
    throw redirect({
      to: '/$slug/auth',
      params: { slug },
    });
  }
}
